import Nullstack from 'nullstack';
export default function IconTestPipeOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-test-pipe-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M20 8.04a803.533 803.533 0 0 0 -4 3.96m-2 2c-1.085 1.085 -3.125 3.14 -6.122 6.164a2.857 2.857 0 0 1 -4.041 -4.04c3.018 -2.996 5.073 -5.037 6.163 -6.124m2 -2c.872 -.872 2.191 -2.205 3.959 -4"
  }), "   ", Nullstack.element("path", {
    d: "M7 13h6"
  }), "   ", Nullstack.element("path", {
    d: "M19 15l1.5 1.6m-.74 3.173a2 2 0 0 1 -2.612 -2.608"
  }), "   ", Nullstack.element("path", {
    d: "M15 3l6 6"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}